export default __webpack_public_path__ + "static/media/appleevent.d53a6400.jpeg";